import { useEffect, useState } from "react";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleScroll = (id: any) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: 'start' });
    }
    setMenuOpen(false);
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="header-container-wrapper">
        <div className="header-container">
          <a
            href="#campa-cola"
            className="header-link"
            onClick={() => handleScroll("campa-cola")}
          >
            CAMPA COLA
          </a>
          <a
            href="#legacy"
            className="header-link"
            onClick={() => handleScroll("legacy")}
          >
            LEGACY
          </a>
          <a
            href="#campa-cricket"
            className="header-link"
            onClick={() => handleScroll("campa-cricket")}
          >
            CAMPA CRICKET
          </a>
          <img
            className="header-logo"
            src="https://campabeveragesadmin.ril.com/uploads/Campa_Logo_2380bb59ca.svg"
            alt="Campa Logo"
          />
          <a
            href="#power-up"
            className="header-link"
            onClick={() => handleScroll("powerBannerr")}
          >
            POWER UP
          </a>
          <a
            href="#product-range"
            className="header-link"
            onClick={() => handleScroll("product-range")}
          >
            PRODUCT RANGE
          </a>
          <a
            href="#fizzy-memories"
            className="header-link"
            onClick={() => handleScroll("fizzy-memories")}
          >
            FIZZY MEMORIES
          </a>
        </div>
      </div>
      {/* Hamburger Menu Icon */}
      <div onClick={toggleMenu}>
        <img
          className="hamburger-icon"
          alt="hamburger-icon"
          src={`${process.env.REACT_APP_BASENAME}/svgs/hamburger.svg`}
        />
      </div>

      {menuOpen && (
        <div className="hamburger-menu">
          <div className="cross-icon" onClick={toggleMenu}>
            ✕
          </div>
          <div style={{ margin: "10px" }}></div>
          <a href="#campa-cola" onClick={() => handleScroll("campa-cola")}>
            CAMPA COLA
          </a>
          <a href="#legacy" onClick={() => handleScroll("legacy")}>
            LEGACY
          </a>
          <a
            href="#campa-cricket"
            onClick={() => handleScroll("campa-cricket")}
          >
            CAMPA CRICKET
          </a>
          <a href="#power-up" onClick={() => handleScroll("power-up")}>
            POWER UP
          </a>
          <a
            href="#product-range"
            onClick={() => handleScroll("product-range")}
          >
            PRODUCT RANGE
          </a>
          <a
            href="#fizzy-memories"
            onClick={() => handleScroll("fizzy-memories")}
          >
            FIZZY MEMORIES
          </a>
        </div>
      )}
    </>
  );
};

export default Header;
